<template>
  <div class="q-pb-sm">
    <q-field class="q-pa-md">
      <q-input
        inverted-light
        color="grey-12"
        rows="7"
        type="textarea"
        float-label="Notes"
        :max-height="100"
        :value="studentForm.STUDENT_NOTES"
        @keyup.stop="updateStudentForm({ field: 'STUDENT_NOTES', value: $event.target.value })"
      />
    </q-field>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'StudentNotes',
  data () {
    return {
      studentForm: this.$store.state.students.studentForm
    }
  },
  methods: {
    ...mapMutations('students', [
      'updateStudentForm'
    ])
  }
}
</script>

<style>
</style>
